<template>
  <TripForm mode="edit" :tripId="tripId" />
</template>

<script setup>
import { useRoute } from "vue-router";

import TripForm from "@/components/forms/TripForm.vue";

const route = useRoute();
const tripId = route.params.id;
</script>
